var React = require('react');

function ShoppingCart (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M552 64H159.21l52.36 256h293.15a24 24 0 0 0 23.4-18.68l47.27-208a24 24 0 0 0-18.08-28.72A23.69 23.69 0 0 0 552 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M218.12 352h268.42a24 24 0 0 1 23.4 29.32l-5.52 24.28a56 56 0 1 1-63.6 10.4H231.18a56 56 0 1 1-67.05-8.57L93.88 64H24A24 24 0 0 1 0 40V24A24 24 0 0 1 24 0h102.53A24 24 0 0 1 150 19.19z","className":"fa-primary","key":2})]);
}

ShoppingCart.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = ShoppingCart;

ShoppingCart.default = ShoppingCart;
